import React from "react";

const EnergyConsumedIcon = ({ size, className = "text-yellow" }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M14.667 8A6.67 6.67 0 0 0 8 1.333 6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M9.168 11.845h1.133v2.88c0 .672.333.808.74.304l2.774-3.44c.34-.42.198-.768-.319-.768h-1.132v-2.88c0-.671-.334-.807-.74-.303l-2.775 3.44c-.337.423-.194.767.32.767"
        />
      </svg>
    </span>
  );
};

export default EnergyConsumedIcon;
